var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M32 14H28.152C26.922 14 26 14.504 26 15.778V18H32L31.524 24H26V40H20V24H16V18H20V14.154C20 10.11 22.128 8 26.922 8H32V14Z","fill":"white","key":0}),React.createElement("path",{"d":"M10 1.5H38C42.6954 1.5 46.5 5.30623 46.5 10V38C46.5 42.6938 42.6954 46.5 38 46.5H10C5.30643 46.5 1.5 42.6936 1.5 38V10C1.5 5.30643 5.30643 1.5 10 1.5Z","stroke":"white","strokeWidth":"3","key":1})]);
}

FacebookIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
